function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { chakra, useStyles } from '@chakra-ui/system';
import React from 'react';
import { usePaginationContext } from '../pagination';
export var PageResults = props => {
  var pageCxt = usePaginationContext();
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    __css: styles.result,
    borderRadius: ""
  }, props), /*#__PURE__*/React.createElement(chakra.p, {
    fontWeight: "semibold"
  }, pageCxt.lowerBoundValue, "-", pageCxt.upperBoundValue), /*#__PURE__*/React.createElement(chakra.p, {
    color: "gray.900"
  }, "of"), /*#__PURE__*/React.createElement(chakra.p, {
    fontWeight: "semibold"
  }, pageCxt.count));
};
//# sourceMappingURL=page-results.js.map